import { useTranslation } from 'react-i18next'
import { PageHeader } from '@/components/sections/PageHeader'
import { CareersSection } from '@/components/sections/CareersSection'
import { Briefcase } from 'lucide-react'
import { PageMeta } from '@/components/PageMeta'

export function CareersPage() {
  const { t } = useTranslation('pages')

  return (
    <>
      <PageMeta title={`${t('careers.title')} — FG Automazioni`} description={t('careers.subtitle')} />
      <PageHeader
        title={t('careers.title')}
        subtitle={t('careers.subtitle')}
        tag={t('careers.tag')}
        icon={Briefcase}
        gradient="cyan"
        showCta={false}
      />
      <CareersSection />
    </>
  )
}
